import banner from './banner';
import button from './button';

const alert = {
  banner,
  button
};

export default alert;
